/**
 * Профиль: данные аккаунта и переходы в разделы.
 */
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { useProfile } from '@/entities/subscription/queries';
import { formatDate } from '@/shared/lib/format';
import { useBackButton } from '@/shared/lib/useBackButton';
import { Screen } from '@/shared/ui/Screen';
import { Card, GroupCaption } from '@/shared/ui/kit/Card';
import { Row } from '@/shared/ui/kit/Row';
import { Sheet } from '@/shared/ui/kit/Sheet';

import styles from './ProfilePage.module.css';

/** Сколько последних операций показывает шторка. */
const RECENT = 10;

/**
 * НАБРОСОК. Платежей в системе ещё нет — PHASE 4. Список нужен, чтобы
 * согласовать вид истории до того, как писать под неё бэкенд.
 */
const DRAFT_TRANSACTIONS = [
  { id: 't1', what: 'VPN, 3 месяца', when: '12 сентября 2026', amount: '539 ₽', kind: 'paid' },
  { id: 't2', what: 'VPN, 1 месяц', when: '12 августа 2026', amount: '199 ₽', kind: 'paid' },
  { id: 't3', what: 'Возврат за 1 месяц', when: '2 августа 2026', amount: '−199 ₽', kind: 'refund' },
  { id: 't4', what: 'VPN, 1 месяц', when: '1 августа 2026', amount: '199 ₽', kind: 'paid' },
  { id: 't5', what: 'VPN, 6 месяцев', when: '30 января 2026', amount: '999 ₽', kind: 'paid' },
  { id: 't6', what: 'VPN, 1 месяц', when: '28 декабря 2025', amount: '199 ₽', kind: 'paid' },
  { id: 't7', what: 'VPN, 1 месяц', when: '27 ноября 2025', amount: '199 ₽', kind: 'paid' },
  { id: 't8', what: 'VPN, 3 месяца', when: '26 августа 2025', amount: '539 ₽', kind: 'paid' },
  { id: 't9', what: 'VPN, 1 месяц', when: '25 июля 2025', amount: '199 ₽', kind: 'paid' },
  { id: 't10', what: 'Пробный период', when: '22 июля 2025', amount: 'Бесплатно', kind: 'trial' },
  { id: 't11', what: 'VPN, 1 месяц', when: '20 июня 2025', amount: '199 ₽', kind: 'paid' },
];

function Transactions() {
  if (DRAFT_TRANSACTIONS.length === 0) {
    return (
      <Card>
        <p className={styles.empty}>Платежей пока не было</p>
      </Card>
    );
  }
  return (
    <Card>
      {DRAFT_TRANSACTIONS.slice(0, RECENT).map((item) => (
        <Row
          key={item.id}
          icon={item.kind === 'refund' ? 'arrowUp' : 'wallet'}
          title={item.what}
          subtitle={item.when}
          value={
            item.kind === 'refund' ? (
              <span className={styles.refund}>{item.amount}</span>
            ) : (
              item.amount
            )
          }
        />
      ))}
    </Card>
  );
}

export function ProfilePage() {
  const navigate = useNavigate();
  const [sheet, setSheet] = useState(false);
  // Профиль — вкладка, своей кнопки «назад» у неё быть не должно. Но пока
  // открыта шторка, нажатие обязано закрывать её, а не сворачивать окно.
  useBackButton(() => setSheet(false), sheet);

  const { data, isLoading, error, refetch } = useProfile();

  return (
    <Screen isLoading={isLoading} error={error} onRetry={() => void refetch()}>
      {data ? (
        <>
          <GroupCaption>Аккаунт</GroupCaption>
          <Card>
            <Row icon="user" title={data.first_name ?? 'Без имени'} subtitle="Имя" />
            {data.username ? (
              <Row icon="user" title={`@${data.username}`} subtitle="Username" />
            ) : null}
            <Row icon="shield" title={String(data.telegram_id)} subtitle="Telegram ID" />
            <Row icon="clock" title={formatDate(data.registered_at)} subtitle="В сервисе с" />
          </Card>

          {/* Разделы идут одной карточкой без заголовка: подпись над ней
              повторяла бы название единственной строки. */}
          <Card>
            <Row icon="wallet" title="История транзакций" onClick={() => setSheet(true)} />
            {data.referral_code ? (
              <Row
                icon="users"
                title="Реферальная программа"
                onClick={() => void navigate('/referral')}
              />
            ) : null}
          </Card>

          <Sheet open={sheet} title="История транзакций" onClose={() => setSheet(false)}>
            <Transactions />
          </Sheet>
        </>
      ) : null}
    </Screen>
  );
}
